module.exports = __webpack_public_path__ + "img/sortez_l_imprimante_3d.10cef029.jpg";